import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Navbar from './components/Navbar'
import Hero from './sections/Hero'
import Promotions from './sections/Promotions'
import Services from './sections/Services'
import Booking from './sections/Booking'
import Testimonials from './sections/Testimonials'
import Contact from './sections/Contact'
import Footer from './components/Footer'

function App() {
  const [scrollY, setScrollY] = useState(0)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll, { passive: true })
    const timer = setTimeout(() => setIsLoaded(true), 300)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className="relative min-h-screen">
      {/* Loading Screen */}
      <AnimatePresence>
        {!isLoaded && (
          <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-[#f8faf7]"
          >
            <div className="text-center">
              <div className="w-12 h-12 border-4 border-[#2d7d32] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
              <p className="text-[#2d7d32] font-semibold">Emeralds Cuts</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.5 }}
      >
        <Navbar scrollY={scrollY} />
        <main>
          <Hero />
          <Promotions />
          <Services />
          <Booking />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
      </motion.div>
    </div>
  )
}

export default App
